'use client'
import React, { useEffect } from 'react'
import styles from './styles.module.scss'
import useCarousel from './hooks'
import Image from 'next/image'

const Carousel = ({ carrosselRef, items }) => {
  const { centralizeItem } = useCarousel(carrosselRef)

  useEffect(() => {
    // Inicializar a centralização do primeiro item visível
    const firstItem = carrosselRef.current?.children[1] // Ignora o clone
    if (firstItem) centralizeItem(firstItem)
  }, [carrosselRef, centralizeItem])

  return (
    <div className={styles.cases}>
      <div className={styles.cases__carrossel} ref={carrosselRef}>
        {Object.values(items).map((item, index) => (
          <div key={index} className={styles.cases__item}>
            <Image src={item.src} alt={item.alt} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default Carousel
